import { render } from "./AllPendingRest.vue?vue&type=template&id=6484b267"
import script from "./AllPendingRest.vue?vue&type=script&lang=js"
export * from "./AllPendingRest.vue?vue&type=script&lang=js"

import "./AllPendingRest.vue?vue&type=style&index=0&id=6484b267&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__